import { UserService, AuthenticationError } from '../../services/user.service';
import  ApiService  from '../../services/api.service'
import { TokenService } from '../../services/storage.service';
import router from '../../router';
import HashMake from '../../services/hash.service';

const state =  {
    authenticating: false,
    accessToken: TokenService.getToken(),
    authenticationSuccess: false,
    authenticationErrorCode: 0,
    authenticationError: [],
    userDetails: TokenService.getUserDetails(),
    userDetailsAddress: TokenService.getUserDetailsAddress(),
    virtualUserDetails: TokenService.getVirtualUserDetails(),
    loading: false,
    isShow: false,
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
};

const getters = {

    userDetails: (state) => state.userDetails,

    userDetailsAddress: (state) => state.userDetailsAddress,

    userPermission: (state) => { 
        return state.userDetails ? state.userDetails.permissions : [];
    },

    virtualUserDetails: (state) => state.virtualUserDetails,

    loggedIn: (state) => {
        return state.accessToken ? true : false;
    },

    authenticationErrorCode: (state) => {
        return state.authenticationErrorCode;
    },

    authenticationError(state){
        return state.authenticationError;
    },

    authenticationSuccess(state){
        return state.authenticationSuccess;
    },

    authenticating: (state) => {
        return state.authenticating;
    },
    isShow: (state) => state.isShow,
    response: (state) => state.response,
    loading: (state) => state.loading
};

const actions = {
    setIsLoggedIn({ commit }) {
        commit('setIsLoggedIn')
    },
    async login({ commit }, formdata) {
        commit('loginRequest');
        commit('setLoading', true)
        try {
            
            const token = await UserService.login(formdata.email, formdata.password, formdata.lang);
            await UserService.fetchUserDetails();
            commit('loginSuccess', token);
            commit('setLoading', false)

            // Redirect the user to the page he first tried to visit or to the home view
            let prevUrl = (localStorage.getItem('previousUrl')) ? localStorage.getItem('previousUrl') : '/'
            router.push(router.history.current.query.redirect || prevUrl);
            
            
            return true;
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message});
                commit('setLoading', false)
            }

            return false;
        }
    },
    async registerCustomer({ commit, dispatch }, data) {
        data.email = HashMake.encrypt(data.email)
        data.password = HashMake.encrypt(data.password)
        data.contact_number = HashMake.encrypt(data.contact_number)
        data.company_vat_number = HashMake.encrypt(data.company_vat_number)
        data.company_name = HashMake.encrypt(data.company_name)
        
        commit('loginRequest');
        commit('setLoading', true)
        return await new Promise((resolve, reject) => {
            ApiService.post('register', data)
            .then(response => {
                commit('setResponse', response.data)
                localStorage.setItem('userDetails', HashMake.encrypt(response.data.userDetails));
                localStorage.setItem('userDetailsAddress', HashMake.encrypt(response.data.userAddress));

                commit('loginSuccess', response.data.access_token);   
                TokenService.saveToken(response.data.access_token);
                TokenService.saveRefreshToken(response.data.access_token);
                ApiService.setHeader();

                resolve();
            })
            .catch(error => {
                
                commit('setRegisterError', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setIsShow', true)
                commit('setLoading', false)
            })
        });

        
    },
    async memberLogin({ commit }, {email, password, lang}) {
        commit('loginRequest');
        try {
            const token = await UserService.memberLogin(email, password, lang);
            commit('loginSuccess', token);
            TokenService.removeGuestToken()
            // Redirect the user to the page he first tried to visit or to the home view
            router.push(router.history.current.query.redirect || '/');
            return true;
        } catch (e) {
            if (e instanceof AuthenticationError) {
                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message});
            }
            return false;
        }
    },
    async storeVirtualUserDetails({ commit }, userDetails) {
        try {
            await TokenService.saveVirtualUserDetails(userDetails);
            await UserService.loginAsCustomer(userDetails);
            router.push('/')
        } catch (e) {
            
        }
    },
    async getVirtualUserDetails({ commit }) {
        try {
            await TokenService.getVirtualUserDetails();
            commit('setVirtualUserDetails', TokenService.getVirtualUserDetails());
        } catch (e) {
            
        }
    },
    logout({ commit }) {
        UserService.logout();
        commit('logoutSuccess');
    },
    clearUserSessionData(){
        UserService.clearUserSessionData();
    },
    async memberLogout({ commit }) {
        try {
            await UserService.logoutAsCustomer();
            router.push('/')
        } catch (e) {
            
        }
        commit('memberLogoutSuccess');
    },
    setIsShow({ commit }, value) {
        commit('setIsShow', value)
    }
};

const mutations = {
    setIsLoggedIn(state) {
        if (!TokenService.getToken()) {
            state.accessToken = false
        }
    },
    loginRequest(state) {
        state.authenticating = true;
        state.authenticationError = '';
        state.authenticationErrorCode = 0;
    },

    loginSuccess(state, accessToken) {
        state.accessToken = accessToken;
        state.userDetails = TokenService.getUserDetails();
        state.authenticationSuccess = true;
        state.authenticating = false;
    },

    loginError(state, {errorCode, errorMessage}) {

        state.authenticating = false;
        state.authenticationErrorCode = errorCode;
        state.authenticationError = errorMessage;
    },

    logoutSuccess(state) {
        state.accessToken = '';
        state.authenticationSuccess = false;
        state.authenticating = false;
        state.userDetails = '';
        state.virtualUserDetails = '';
    },

    setVirtualUserDetails(state, value) {
        state.virtualUserDetails = value;
    },

    memberLogoutSuccess(state) {
        state.virtualUserDetails = '';
        router.push('/login-as-customer')
    },
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {
        
        state.response.message = data.message;
        if(data.success == true) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    },

    setRegisterError(state, data) {
 
        state.response.message = "";
        state.response.variant = 'danger';
        state.response.errmsg = data;
    },
    setUserDetails(state, data) {
        //userDetails
        state.userDetails = data;

    },
    setUserDetailsAddress(state, data) {
        // userDetailsAddress
        state.userDetailsAddress = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};